/** @format */

import signDustLogs from './sign';
import homeDustLogs from './home';
import discoveryDustLogs from './discovery';
import ourStoryDustLogs from './ourStory';
import readingListDustLogs from './readingList';
import jobsDustLogs from './jobs';
import paperDustLogs from './paper';
import userDustLogs from './user';

const allLogs = {
  ...signDustLogs,
  ...homeDustLogs,
  ...discoveryDustLogs,
  ...ourStoryDustLogs,
  ...readingListDustLogs,
  ...jobsDustLogs,
  ...paperDustLogs,
  ...userDustLogs,
};

export default allLogs;
